import { Link } from '@tanstack/react-router';

type Tab = 'overview' | 'cache' | 'cerbo-ids' | 'review' | 'quarantine';

/**
 * Shared sub-navigation for a session and its three sub-pages
 * (overview / imported records / review queue / quarantine). Before this, each
 * sub-page only had an ad-hoc "← Back to session" link and you could not move
 * laterally between them; the overview page only linked to the cache. The
 * Overview tab doubles as the back-link, so callers can drop their own.
 */
export function SessionTabs({ sessionId, active }: { sessionId: string; active: Tab }) {
  const base = 'rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors';
  const props = (t: Tab) =>
    t === active
      ? { className: base, style: { background: 'var(--accent-blue)1f', color: 'var(--accent-blue)', border: '1px solid var(--accent-blue)55' } }
      : { className: `${base} hover:text-text-secondary`, style: { color: 'var(--text-dimmed)', border: '1px solid transparent' } };
  return (
    <nav className="flex items-center gap-1.5">
      <Link to="/sessions/$id" params={{ id: sessionId }} {...props('overview')}>Overview</Link>
      <Link to="/sessions/$id/cache" params={{ id: sessionId }} {...props('cache')}>Records</Link>
      <Link to="/sessions/$id/id-map" params={{ id: sessionId }} {...props('cerbo-ids')}>Cerbo IDs</Link>
      <Link to="/sessions/$id/review" params={{ id: sessionId }} {...props('review')}>Review</Link>
      <Link to="/sessions/$id/quarantine" params={{ id: sessionId }} {...props('quarantine')}>Quarantine</Link>
    </nav>
  );
}
